import { render, staticRenderFns } from "./ViewCompOffRequestsModal.vue?vue&type=template&id=4518df66&"
import script from "./ViewCompOffRequestsModal.vue?vue&type=script&lang=js&"
export * from "./ViewCompOffRequestsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports